import { render } from "./SectionTwo.vue?vue&type=template&id=4b652836&scoped=true"
const script = {}

import "./SectionTwo.vue?vue&type=style&index=0&id=4b652836&lang=css&scoped=true"

import exportComponent from "/Users/konradfigura/Developer/first-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b652836"]])

export default __exports__